import React from 'react';
import {useI18nContext} from "../../../contexts/I18nContext";
import {Observer} from "mobx-react-lite";
import useConfirmation from "../../../hooks/ConfirmationDialog";
import ConfirmArticleOrderDeliveredButtonProperties from './ConfirmArticleOrderDeliveredButtonProperties';
import Link from '../../../ui_components/Link/Link';
import { useCommonContext } from '../../../contexts/CommonContext';
import ConfirmArticleOrderDeliveredStore from './ConfirmArticleOrderDeliveredStore';
import { useUserContext } from '../../../contexts/UserContext';

const ConfirmArticleOrderDeliveredButton: React.FC<ConfirmArticleOrderDeliveredButtonProperties> = ({
                                                                                  deliveryPersonId,
                                                                                  articleDeliveryId,
                                                                                  onUpdate = () => {},
}) => {

    const i18n = useI18nContext();
    const confirm = useConfirmation();
    const commonContext = useCommonContext();
    const userStore = useUserContext();
    const store = new ConfirmArticleOrderDeliveredStore(commonContext, deliveryPersonId, articleDeliveryId);

    if (!userStore.isRootAgency()) {
        return <></>;
    }

    const handleOnclick = async () => {
        const success = await confirm(i18n.translate("CONFIRM_DELIVERED_CONFIRMATION"), '');
        if(success){
            const result = await store.confirmDelivered();
            if (result) {
                onUpdate(result);
            }
        }       
    }

    const text = i18n.translate("CONFIRM_DELIVERED");


    return <Observer>
        {() => (
            <>
                <div><Link text={text} onClick={handleOnclick} disabled={store.loading}></Link></div>
            </>
        )}
    </Observer>
}

export default ConfirmArticleOrderDeliveredButton;
